import { render, staticRenderFns } from "./DDAllianceAuthorization.vue?vue&type=template&id=34e605aa"
import script from "./DDAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./DDAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e605aa')) {
      api.createRecord('34e605aa', component.options)
    } else {
      api.reload('34e605aa', component.options)
    }
    module.hot.accept("./DDAllianceAuthorization.vue?vue&type=template&id=34e605aa", function () {
      api.rerender('34e605aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/DDAllianceAuthorization.vue"
export default component.exports